import {
    cleanupVideoInput,
    formatFileSize,
    isSupportedVideoFile,
    loadFFmpeg,
    prepareVideoInput,
} from '../compress/compressVideoEngine';

export {
    formatFileSize,
    isSupportedVideoFile,
};

export const MAX_REMOVE_AUDIO_VIDEO_BYTES = 200 * 1024 * 1024;

export function removeAudioVideoName(fileName) {
    const base = (fileName || 'video').replace(/\.[^.]+$/, '');
    return `${base}-no-audio.mp4`;
}

/**
 * @param {File} file
 * @param {(progress: number) => void} onProgress
 * @returns {Promise<Blob>}
 */
export async function removeAudioFromVideo(file, onProgress = () => {}) {
    let ffmpeg;
    let videoInput = null;
    const outputName = 'remove-audio-output.mp4';

    try {
        ffmpeg = await loadFFmpeg();
        videoInput = await prepareVideoInput(ffmpeg, file);

        const progressHandler = ({ progress }) => {
            onProgress(Math.round(Math.min(progress * 100, 100)));
        };
        ffmpeg.on('progress', progressHandler);

        const exitCode = await ffmpeg.exec([
            '-i', videoInput.inputPath,
            '-an',
            '-vcodec', 'copy',
            '-movflags', '+faststart',
            outputName,
        ]);

        ffmpeg.off('progress', progressHandler);

        if (exitCode !== 0) {
            try { await ffmpeg.deleteFile(outputName); } catch (_) { /* ignore */ }
            throw new Error('ENCODE_FAILED');
        }

        const data = await ffmpeg.readFile(outputName);
        try { await ffmpeg.deleteFile(outputName); } catch (_) { /* ignore */ }

        if (!data || data.length === 0) {
            throw new Error('EMPTY_OUTPUT');
        }

        return new Blob([data], { type: 'video/mp4' });
    } catch (error) {
        const msg = (error?.message || '').toLowerCase();
        if (msg.includes('memory') || msg.includes('allocate') || msg.includes('oom')) {
            throw new Error('OUT_OF_MEMORY');
        }
        if (error?.message === 'ENCODE_FAILED' || error?.message === 'EMPTY_OUTPUT') {
            throw error;
        }
        throw new Error('REMOVE_AUDIO_FAILED');
    } finally {
        if (ffmpeg && videoInput) {
            await cleanupVideoInput(ffmpeg, videoInput);
        }
    }
}
